import RespostaRadio from "./RespostaRadio.vue";
import UltimaResposta from "./UltimaResposta.vue";
import RespostaTextarea from "./RespostaTextarea.vue";
import RespostaCheckbox from "./RespostaCheckbox.vue";
import RepsostaEscalaLikert from "./RepsostaEscalaLikert.vue";

export const respostaComponentRegistry = {
  C: RespostaRadio,
  U: RespostaRadio,
  M: RespostaCheckbox,
  L: RepsostaEscalaLikert
};

export function getRespostaComponent(tipoResposta, pergunta = null) {
  if (tipoResposta === "D" && Boolean(pergunta?.ultima_pergunta) === true) {
    return UltimaResposta;
  }

  if (tipoResposta === "D" && Number(pergunta?.cd_pergunta) !== 1) {
    return RespostaTextarea;
  }

  return respostaComponentRegistry[tipoResposta] || null;
}
